import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=10152d43&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=10152d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10152d43",
  null
  
)

export default component.exports